import { useEffect, useState } from 'react';
import { fetchParaOpens } from '../services/paraApi';

/**
 * Whether Para opens on this client (server/lib/clientAllocation/allocation.cjs → paraOpensForClient):
 * in a firm running the Para trial, only on trial clients. Null until known or if the check fails (the
 * server still refuses), and kept with the client it belongs to so a client switch never shows the
 * last client's answer.
 */
export default function useParaOpens(clientId, { enabled = true } = {}) {
  const [state, setState] = useState({ clientId: null, opens: null });

  useEffect(() => {
    if (!enabled || !clientId) return undefined;
    const controller = new AbortController();
    fetchParaOpens(clientId, { signal: controller.signal })
      .then((opens) => setState({ clientId, opens }))
      .catch(() => { if (!controller.signal.aborted) setState({ clientId, opens: null }); });
    return () => controller.abort();
  }, [clientId, enabled]);

  return state.clientId === clientId ? state.opens : null;
}
